/* eslint-disable @typescript-eslint/no-explicit-any */
// import Select, { createFilter } from "react-select";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import { useState } from "react";
import { ListModel } from "../../../app/models/list-model";
import "./autocomplete-select.scss";

/* eslint-disable-next-line */
export interface AutocompleteSelectProps {
  //react-hook-form props
  // field: any;
  register?: any;
  getFieldState?: any;
  formState?: any;
  errors?: any;
  //select props
  name: string;
  label?: string;
  placeholder?: string;
  isMultiple: boolean;
  options: Array<ListModel>;
  required?: boolean;
  selectRef?: any;
  isClearable?: boolean;
  disabled?: boolean;
  hideSelectedValues?: boolean;
  handleChangeOption?: any;
  handleCreate?: (value: string) => void;
  showAssistiveTextAlways?: boolean;
  onChange: (value: string) => void;
  helperText?: string;
}

export function AutocompleteSelect(props: AutocompleteSelectProps) {
  // const { isDirty, isTouched } = props.getFieldState(
  //   props.name,
  //   props.formState
  // );

  const [value, setValue] = useState<string>("");

  return (
    <div className="autocomplete-select-container">
      {props.options && props.register && (
        <FormControl required={props.required} fullWidth>
          <Autocomplete
            {...props.register(props.name)}
            value={value}
            disablePortal
            options={props.options}
            renderInput={(params) => (
              <TextField {...params} label={props.label} />
            )}
            disabled={props.disabled}
            id={props.name}
            onChange={(event, newInputValue: any) => {
              props.onChange(newInputValue?.value);
              setValue(newInputValue);
            }}
            onInputChange={(event: any, newValue: string | null) => {
              if (
                newValue !== null &&
                newValue.length > 3 &&
                props.handleCreate
              )
                props.handleCreate(newValue);
            }}
          />
          {props.helperText && (
            <p className="assistive-text">{props.helperText}</p>
          )}
        </FormControl>
      )}

      {props.options && !props.register && (
        <FormControl required={props.required} fullWidth>
          <Autocomplete
            // value={value}
            disablePortal
            options={props.options}
            renderInput={(params) => (
              <TextField {...params} label={props.label} />
            )}
            disabled={props.disabled}
            id={props.name}
            onChange={(event, newInputValue: any) => {
              props.onChange(newInputValue?.value);
              setValue(newInputValue);
            }}
            onInputChange={(event: any, newValue: string | null) => {
              if (
                newValue !== null &&
                newValue.length > 3 &&
                props.handleCreate
              )
                props.handleCreate(newValue);
            }}
          />
          {props.helperText && (
            <p className="assistive-text">{props.helperText}</p>
          )}
        </FormControl>
      )}
    </div>
  );
}

export default AutocompleteSelect;
